<template>
    <div class="h-100">
        <div class="pl-2 pr-2 container-fluid">
            <div class="col-lg-12 mx-auto pb-3 mt-3" id="main-body">
                <div class="row">
                    <div class="col-lg-3 pt-3">
                        <div>
                            <div class="card">
                                <div class="card-header m-2 p-2 print-hide" id="filters-container">
                                    <div>
                                        <div class="btn-group" role="group">
                                             <button type="button"
                                                    v-if="order_search_enabled"
                                                    class="btn btn-primary-outline btn-close btn-card filter search-icon"
                                                    @click="changeFilter('SEARCH')"
                                                    :class="{ selected: filter==='SEARCH'}">
                                                <icon name="search"></icon>
                                            </button>
                                            <button type="button"
                                                    class="btn btn-primary-outline btn-close btn-card filter"
                                                    @click="changeFilter('CREATED')"
                                                    :class="{ selected: filter==='CREATED'}">
                                                New
                                                <span class="badge badge-light custom-badge">
                                                    {{filter_counts['created']}}
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="btn btn-primary-outline btn-close btn-card filter"
                                                    @click="changeFilter('ACCEPTED')"
                                                    :class="{ selected: filter==='ACCEPTED'}">
                                                In Progress
                                                <span class="badge badge-light custom-badge">
                                                    {{filter_counts['accepted'] + filter_counts['ready'] + filter_counts['dispatched']}}
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="btn btn-primary-outline btn-close btn-card filter"
                                                    @click="changeFilter('COMPLETED')"
                                                    :class="{ selected: filter==='COMPLETED'}">
                                                Completed
                                                <span class="badge badge-light custom-badge">
                                                    {{filter_counts['completed']}}
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="btn btn-primary-outline btn-close btn-card filter"
                                                    @click="changeFilter('REJECTED')"
                                                    :class="{ selected: filter==='REJECTED'}">
                                                Rejected
                                                <span class="badge badge-light custom-badge">
                                                    {{filter_counts['rejected']}}
                                                </span>
                                            </button>
                                            <button type="button"
                                                    class="btn btn-primary-outline btn-close btn-card filter"
                                                    @click="changeFilter('CANCELLED')"
                                                    :class="{ selected: filter==='CANCELLED'}">
                                                Cancelled
                                                <span class="badge badge-light custom-badge">
                                                    {{filter_counts['cancelled']}}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" id="orders-outer-container">
                                    <ul id="orders-container" ref="orders_container"
                                        class="list-group list-group-flush" v-if="orders">

                                        <div class="p-2 m-0" id="search-container" v-if="filter == 'SEARCH'">
                                            <input id="search-query" type="text" placeholder="Order ref" class="form-control" v-model="search_query" required>
                                        </div>

                                        <div class="alert alert-primary no-data-alert" role="alert"
                                            v-if="filteredOrders.length === 0">
                                            No order to display
                                        </div>
                                        <li class="list-group-item order-selector" v-for="order in filteredOrders"
                                            :key="order.id"
                                            :class="{ selected: orderSelected(order)}"
                                            @click="showOrder(order)">
                                            <div class="float-right mr-2 order-selector-text">
                                                <p class='text-right order-selector-text-date'>
                                                    {{orderDueDate(order)}}
                                                </p>
                                                <img :src="order.vendor_image"
                                                     class="rounded ml-auto d-block vendor-image"
                                                     :alt="order.vendor_name">
                                            </div>
                                            <div class="ml-2 order-selector-text">
                                                <p class="order-selector-text-ref">
                                                    #{{order.order_ref}}
                                                    <icon class="ml-2" name="car"
                                                          v-if="order.fulfilment_type === 'DELIVERY'"></icon>
                                                    <icon class="ml-2" name="shopping-basket"
                                                          v-if="order.fulfilment_type === 'COLLECTION'"></icon>
                                                    <icon class="ml-2" name="utensils"
                                                          v-if="order.fulfilment_type === 'DROPOFF'"></icon>
                                                </p>
                                                <p>
                                                    {{order.user.name}}
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-9 pt-3 " v-if="!selected_order">
                        <div class="card">
                            <div class="card-body pt-3 mt-3">
                                <div class="alert alert-primary m-0" role="alert" v-if="!selected_order">
                                    You have not selected an order
                                </div>
                                <img src="/images/goodeats-lg.png" class="img-fluid" alt="Goodeats by Goodtill">
                                <div class="float-right">
                                    <img src="/images/goodeats-logo.png" id="goodeats-logo" class="img-fluid"
                                         alt="Responsive image">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 pt-3" ref="order_details_section" v-if="selected_order">
                        <div class="card">
                            <div class="card-body">
                                <button type="button" class="btn btn-link btn-status float-right" @click="printOrder">
                                    Print Order
                                </button>
                                <span class="custom-header pb-2">
                                    Order Ref: <strong>{{selected_order.order_ref}}</strong>
                                </span>
                                <br>
                                <span>
                                    Fulfillment: {{selected_order.fulfilment_type_name}}
                                    <template v-if="selected_order.collection_point_name">
                                        {{ selected_order.collection_point_name }}
                                    </template>
                                </span>
                                <span v-if="selected_order.sale.table_cover">
                                    <br>
                                    Covers: {{ selected_order.sale.table_cover }}
                                </span>
                                <div class="mt-1" v-if="selected_order.oc_sale_group" >
                                    <icon name="layer-group" color="grey"/>
                                    This order is part of a {{ selected_order.oc_sale_group.oc_sales_metas.length }}
                                    part multi-vendor order from {{ selected_order.oc_sale_group.oc_config.store_display_name }}.
                                </div>
                                <hr>
                                <div class="pb-2 print-font-20">
                                    Created: {{formatDate(selected_order.created_at)}}
                                </div>
                                <div class="pb-2 print-font-20" v-if="selected_order.requested_at">
                                    Requested: {{formatDate(selected_order.requested_at)}}
                                    <small v-show="selected_order.requested_time_asap">(ASAP)</small>
                                </div>
                                <div v-if="selected_order.requested_at && selected_order.order_status === 'CREATED'" class = "row">
                                    <div class="form-group col-md-6 col-lg-8">
                                        <span class="print-font-20 col-md-3 float-left text-left p-0">Due:</span>
                                        <select v-if="!use_date_picker" class="form-control col-md-9 print-hide"
                                                v-model="additional_status_data.delay">
                                            <option :value="0" :selected='true'>
                                                {{getRequestedTime(selected_order)}}
                                            </option>
                                            <option v-for="time in [5, 10, 15, 30, 45, 60, 75, 90]" :value="time" :key="time">
                                                +{{time}} Minutes
                                            </option>
                                        </select>
                                        <div v-else class="max-width-350 print-hide">
                                            <datetime :min-datetime="orderMinDate(selected_order)" type="datetime" v-model="additional_status_data.expected_date"></datetime>
                                        </div>
                                        <span class="print-show font-18">{{selected_order.requested_time}}</span>
                                    </div>
                                    <div class="col-md-6 col-lg-4">
                                        <button type="button" class="btn btn-dark-bg" @click="use_date_picker = !use_date_picker">
                                           {{use_date_picker ? "Use delay" : "Use date"}}
                                        </button>
                                    </div>
                                 </div>
                                <span v-else>
                                    <span
                                        class="print-font-20"
                                        v-if="selected_order.order_status !== 'CREATED' &&
                                        (selected_order.requested_at || selected_order.expected_at)">
                                        Due: <span>{{orderDueDate(selected_order)}}</span>
                                    </span>
                                    <span v-else class="print-font-20">
                                        No due time
                                    </span>
                                </span>
                                <hr>
                                <div class="float-right print-hide" v-show="selected_order.customer_order_count_total !== null">
                                    <div class="vertical-middle custom-header-min text-right">
                                         {{(selected_order.customer_order_count_total > 1) ? 'Returning Customer' : 'New Customer'}}
                                        <p class="mt-1" v-show="selected_order.customer_order_count_total > 1">
                                            {{selected_order.customer_order_count_total}} Orders
                                            ({{selected_order.customer_order_count_30_days}} Recent)
                                        </p>
                                    </div>
                                </div>
                                <div v-if="selected_order.user" class="print-font-20">
                                    <div>
                                        <div class="mb-1">
                                            <icon class="mr-3" name="user" color="gray"></icon>
                                            {{selected_order.user.name}}
                                         </div>
                                        <div v-if="selected_order.user.phone">
                                            <icon class="mr-3" name="phone" color="gray"></icon>
                                            <a class="phone-number"
                                                   :href="'tel:' + selected_order.user.phone">{{selected_order.user.phone}}
                                            </a>
                                        </div>
                                    </div>
                                    <template v-if="selected_order.fulfilment_type === 'DELIVERY' && stringEmpty(selected_order.user.address.address) == false">
                                        <div class="pb-3 mt-1">
                                            <icon class="mr-3 float-left" name="map-marked" color="gray"></icon>
                                            <div class="card-text m-0 avoid-wrap">
                                                {{selected_order.user.address.address}}<br>
                                                {{selected_order.user.address.city}}<br>
                                                {{selected_order.user.address.postcode}}
                                                <p class="card-text font-italic m-0 delivery-notes"
                                                   v-if="selected_order.user.address.notes && selected_order.user.address.notes.length > 0"
                                                    >{{`"${selected_order.user.address.notes}"`}}</p>
                                            </div>
                                        </div>
                                        <div class="mt-1 print-hide">
                                            <span v-if="selected_order.user.address_distance_miles === null" class="col-red">
                                                Address distance could not be determined - please check the distance before accepting
                                            </span>
                                            <span v-else>
                                                Approximately {{ selected_order.user.address_distance_miles }} miles by road
                                            </span>
                                        </div>
                                    </template>
                                </div>
                                <hr v-if="selected_order.fulfilment_type == 'DELIVERY' && !['CREATED', 'CANCELLED', 'REJECTED'].includes(selected_order.order_status)">
                                <div class="row" v-if="selected_order.fulfilment_type == 'DELIVERY'
                                    && !['CREATED', 'CANCELLED', 'REJECTED'].includes(selected_order.order_status)"
                                >
                                    <div class="col print-font-20" v-if="selected_order">
                                        Delivery via:
                                        <span v-if="!(selected_order.deliveries && selected_order.deliveries.length > 0
                                            && selected_order.deliveries[0].status != 'CANCELLED')">
                                            Deliver by store
                                        </span>
                                        <span v-if="(selected_order.deliveries && selected_order.deliveries.length > 0
                                            && selected_order.deliveries[0].status != 'CANCELLED')">
                                            {{selected_order.deliveries[0].vendor_name}} ({{selected_order.deliveries[0].status_name}})
                                        </span>
                                    </div>
                                    <div class="col"
                                         v-if="(selected_order.deliveries.length < 1 || selected_order.deliveries[0].status == 'CANCELLED')
                                            && selected_order.order_status === 'ACCEPTED' && enable_delivery_services">
                                        <button type="button" class="btn btn-success btn-close float-right btn-150"
                                                @click="getDeliveryServices">Request Delivery
                                        </button>
                                    </div>
                                    <div class="col"
                                         v-if="selected_order.deliveries.length > 0 && selected_order.deliveries[0].status != 'CANCELLED'">
                                        <button type="button" class="btn btn-success btn-close float-right btn-150"
                                                @click="showDeliveryDetails">View Delivery
                                        </button>
                                    </div>
                                </div>
                                <span>
                                    <hr>
                                    <p class="m-0">
                                        Channel: {{selected_order.vendor_name}}
                                    </p>
                                    <p>
                                        Order status: {{selected_order.order_status_name}}
                                    </p>
                                </span>
                                <div v-if="selected_order">
                                    <!-- <hr> -->
                                    <button type="button" class="btn btn-danger btn-status"
                                            @click="showRejectModal(); status_action = 'REJECTED'; status_action_text = 'Reject'"
                                            v-if="selected_order.order_status === 'CREATED'">Reject
                                    </button>
                                    <button type="button" class="btn btn-danger btn-status"
                                            @click="showRejectModal(); status_action = 'CANCELLED'; status_action_text = 'Cancel'"
                                            v-if="['ACCEPTED', 'READY', 'DISPATCHED'].includes(selected_order.order_status)">
                                        Cancel
                                    </button>
                                    <button type="button" class="btn btn-success float-right btn-status"
                                            @click="changeStatus('ACCEPTED')"
                                            v-if="selected_order.order_status === 'CREATED'">Accept
                                    </button>
                                    <button type="button" class="btn btn-danger float-right btn-status"
                                            @click="changeStatus('DISPATCHED')"
                                            v-if="selected_order.order_status === 'ACCEPTED' && selected_order.fulfilment_type === 'DELIVERY' && selected_order.allow_status_update">
                                        Dispatch
                                    </button>
                                    <button type="button" class="btn btn-danger float-right ml-2 btn-status"
                                            @click="changeStatus('READY')"
                                            v-if="selected_order.order_status === 'ACCEPTED'
                                            && selected_order.fulfilment_type === 'COLLECTION' && selected_order.order_status !== 'READY' && selected_order.allow_status_update">
                                        Ready
                                    </button>
                                </div>

                                <div class="mt-3 text-center">
                                    <button type="button" class="btn btn-danger btn-close btn-block text-center"
                                            @click="changeStatus('COMPLETED')"
                                            v-if="(['ACCEPTED', 'READY', 'DISPATCHED'].includes(selected_order.order_status) || selected_order.allow_status_update == false) && sale_due == 0">
                                        Completed
                                    </button>
                                    <button type="button" class="btn btn-danger text-center btn-block"
                                            @click="beginRecordPayment"
                                            v-if="this.sale_due > 0 && selected_order.payment_method !== 'WEBCARD'
                                            && ['ACCEPTED', 'READY', 'DISPATCHED'].includes(selected_order.order_status)">
                                        Take payment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-5 pt-3 mb-3" v-if="selected_order">
                        <div class="card">
                            <div class="card-body">
                                <span v-if="selected_order.sale">
                                    <p v-if="selected_order.sale.order_notes" class="sale-notes"
                                        >Order notes: {{selected_order.sale.order_notes}}</p>
                                </span>
                                <div>
                                    <ul class="list-group list-group-flush border sale-items-container"
                                        v-if="selected_order.sale">
                                        <!-- Sale items -->
                                        <li class="list-group-item print-lg"
                                            v-for="product in selected_order.sale.sale_items" :key="product.id">
                                            <span
                                                class="badge badge-primary float-left mr-3 font-14 quantity-container">{{product.quantity}}</span>
                                            <span class="float-right">{{currency}}{{(parseFloat(product.price_inc_vat_per_item) * product.quantity).toFixed(2)}}</span>
                                            {{product.product_name}}
                                            <p v-if="product.item_notes" class="text-muted product-extra print-lg ml-5 pl-1">
                                                {{'\n'+product.item_notes}}
                                            </p>
                                        </li>
                                        <!-- Service charge -->
                                        <li class="list-group-item print-lg ml-5 pl-4"
                                            v-if="selected_order.sale.service_charge && selected_order.sale.service_charge != 0">
                                            <span class="float-right">
                                                {{currency + parseFloat(selected_order.sale.service_charge).toFixed(2)}}</span>
                                            Service charge
                                        </li>
                                         <!-- Delivery charge -->
                                         <li class="list-group-item print-lg ml-5 pl-4"
                                            v-if="selected_order.sale.delivery_charge && selected_order.sale.delivery_charge != 0">
                                            <span class="float-right">
                                                {{currency + parseFloat(selected_order.sale.delivery_charge).toFixed(2)}}</span>
                                            Delivery charge
                                        </li>
                                        <!-- Tip -->
                                         <li class="list-group-item print-lg ml-5 pl-4"
                                            v-if="selected_order.sales_tips > 0">
                                            <span class="float-right">
                                                {{currency + parseFloat(selected_order.sales_tips).toFixed(2)}}</span>
                                            {{ selected_order.tips_label }}
                                        </li>
                                    </ul>

                                    <!-- Payment list -->
                                    <ul class="list-group list-group-flush border sale-items-container sale-payments-container"
                                        v-show="selected_order.sale.sale_payments.length > 0">
                                         <li class="list-group-item print-lg ml-5 pl-4" v-for="payment in selected_order.sale.sale_payments"
                                             v-show="payment.payment_amount_inc_tips > 0">
                                            <span class="float-right">
                                                {{currency + parseFloat(payment.payment_amount_inc_tips).toFixed(2)}}</span>
                                            {{ payment.payment_method_name }}
                                        </li>
                                    </ul>

                                    <div class="mt-5 justify-content-center d-flex mb-3">
                                        <div class="text-center d-flex align-items-center" id='payment-status'>
                                            <div v-if="this.sale_due == 0"
                                                 class="vertical-middle mx-auto d-flex align-items-center float-right paid-container">
                                                <span class="text-center mx-auto payment-text">
                                                    Paid
                                                </span>
                                            </div>
                                            <div v-else
                                                 class="vertical-middle mx-auto d-flex align-items-center float-right unpaid-container">
                                                <span class="text-center mx-auto payment-text">
                                                    Unpaid
                                                </span>
                                            </div>
                                            <span class="vertical-middle pl-5 text-left">
                                                 <span class="font-weight-medium text font-18">Total: {{currency + parseFloat(total).toFixed(2)}}</span>
                                                <p class="mt-3">
                                                    Paid: {{currency + parseFloat(total_paid).toFixed(2)}}
                                                </p>
                                                <p>
                                                    Due: {{currency + sale_due}}
                                                </p>

                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- reject / cancel order modal -->
        <div v-if="show_reject_order_modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{status_action_text}} order?</h5>
                                    <button type="button" class="close noSelect" data-dismiss="modal"
                                            aria-label="Close" @click="cancelReject">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body text-center">
                                    <p>
                                        Are you sure you want to {{status_action_text.toLowerCase()}} this order?<br>
                                        This will remove the sale and refund the customer.
                                    </p>
                                    <p v-for="(reason, index) in cancellation_reasons" :key="index"
                                       @click="appendToNote(reason)"
                                       class="font-italic text-muted pt-2 cursor-hover">
                                        {{reason}}
                                    </p>
                                    <div class="form-group pt-4">
                                        <p class="text-left font-weight-medium">Reason (visible to customer)</p>
                                        <textarea placeholder="Add sale note ..." class="form-control" :rows="4"
                                                  v-model="additional_status_data.notes"></textarea>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-primary-outline btn-close"
                                            @click="cancelReject">Cancel
                                    </button>
                                    <button type="button" class="btn btn-danger" @click="changeStatus(status_action)">
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- end -->
        <!-- request delivery modal -->
        <div v-if="show_request_delivery_modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Choose delivery service</h5>
                                    <button type="button" class="close noSelect" data-dismiss="modal" aria-label="Close"
                                            @click="show_request_delivery_modal = false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body text-center">
                                    <p class="pb-2">
                                        Request collection at
                                        <vue-timepicker format="HH:mm" v-model="delivery_time"></vue-timepicker>
                                    </p>
                                    <ul class="list-group list-group-flush delivery-services-container">
                                        <li class="list-group-item row delivery-service"
                                            v-for="service in delivery_services"
                                            :key="service.vendor">
                                            <div class="float-right mr-2 mb-2">
                                                <p v-if="service.failure_reason">
                                                    {{service.failure_reason}}
                                                </p>
                                                <button v-else type="button" class="btn btn-danger"
                                                        @click="requestDelivery(service)">
                                                    Select service
                                                </button>
                                            </div>
                                            <div class="ml-2">
                                                <img :src="service.vendor_image"
                                                     class="rounded ml-auto d-block float-left vendor-img mb-2"
                                                     :alt="service.vendor_name">
                                                <span v-if="!service.failure_reason" class="text-center">
                                                     <select class="form-control col-lg-4 text-center mx-auto mb-2"
                                                             v-model="service.details.default_package_size">
                                                        <option v-for="size in service.details.package_sizes" :value="size.id"
                                                                :key="size.id">
                                                            {{size.name}} - {{size.description}}
                                                        </option>
                                                    </select>
                                                </span>
                                                <span v-if="!service.failure_reason" class="float-left text-left">
                                                    <p class="pt-1 m-0">
                                                        Approximately <strong class="font-18">{{currency + service.details.estimated_cost}}</strong> (ex. VAT)
                                                    </p>
                                                    <p class="mt-2">
                                                        {{service.details.notes}}
                                                    </p>
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="modal-footer">
                                    <div class="text-center">
                                        If you're delivering with your own drivers, manually mark the order as
                                        dispatched instead
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--end-->
        <!-- process payment modal -->
        <div v-if="show_payment_modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Take payment</h5>
                                    <button type="button" class="close noSelect" data-dismiss="modal"
                                            aria-label="Close" @click="show_payment_modal = false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body text-center p-0 pr-2 pl-2">
                                    <div class="row pl-2 pr-2">
                                        <div class="col-md-6 p-3">
                                            Total to Pay
                                            <div class="font-big font-weight-medium">
                                                {{currency + sale_due}}
                                            </div>
                                        </div>
                                        <div class="col-md-6 bg-whitesmoke p-3">
                                            Amount Tendered
                                            <div class="font-big font-weight-medium">
                                                {{currency + this.payment.payment_amount}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col">
                                            <button type="button" class="btn btn-success btn-payment"
                                                    @click="recordPayment(true)">Cash
                                            </button>
                                        </div>
                                        <div class="col">
                                            <button type="button" class="btn btn-dark-bg btn-payment"
                                                    @click="recordPayment()">Card
                                            </button>
                                        </div>
                                    </div>
                                    <p class="mt-5">
                                        Quick cash payment
                                    </p>
                                    <div class="row pl-5 pr-5">
                                        <button class="col m-3 mt-2 btn-dark-bg btn" v-for="amount in [5, 10, 20, 50]"
                                                :key="amount" @click="tenderAmount(amount)">
                                            {{currency + amount}}
                                        </button>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-primary-outline btn-close"
                                            @click="show_payment_modal = false">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- end -->
        <!-- delivery details modal -->
        <div v-if="show_delivery_details_modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Delivery details</h5>
                                    <button type="button" class="close noSelect" data-dismiss="modal" aria-label="Close"
                                            @click="show_delivery_details_modal = false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body text-center">
                                    <ul class="list-group list-group-flush delivery-services-container">
                                        <li class="list-group-item row delivery-service">
                                            <div class="float-right mr-2 mb-2">
                                                <button type="button" class="btn btn-danger"
                                                        @click="showCancelDelivery">
                                                    Cancel delivery
                                                </button>
                                            </div>
                                            <div class="ml-2">
                                                <img :src="selected_order.deliveries[0].vendor_image"
                                                     class="rounded ml-auto d-block float-left vendor-img mb-2"
                                                     :alt="selected_order.deliveries[0].vendor_name"
                                                 >
                                            </div>
                                        </li>
                                    </ul>
                                    <div id="delivery-map" class="d-flex align-items-center">
                                        <icon v-if="show_map_spinner" color="gray" name="circle-notch"
                                            class="mx-auto" scale="1.5" spin></icon>
                                        <iframe
                                            v-show="!show_map_spinner"
                                            @load="show_map_spinner = false"
                                            :src="selected_order.deliveries[0].tracking_url"
                                            height="100%"
                                            width="100%"
                                            frameBorder="0"
                                        >
                                        </iframe>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <div class="text-center">
                                        <button type="button" class="btn btn-primary-outline btn-close"
                                            @click="show_delivery_details_modal = false">Close
                                         </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--end-->
        <!--cancel delivery modal-->
        <div v-if="show_cancel_delivery_modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Cancel this delivery?</h5>
                                    <button type="button" class="close noSelect" data-dismiss="modal"
                                            aria-label="Close" @click="show_cancel_delivery_modal = false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body text-center">
                                    <p>
                                        Are you sure you want to cancel this delivery?<br>
                                        This will send a notification to the delivery service.
                                    </p>
                                    <p v-for="(reason, index) in delivery_cancellation_reasons" :key="index"
                                       @click="appendToCancelDeliveryNote(reason)"
                                       class="font-italic text-muted pt-2 cursor-hover">
                                        {{reason}}
                                    </p>
                                    <div class="form-group pt-4">
                                        <p class="text-left font-weight-medium">Reason</p>
                                        <textarea placeholder="Add sale note ..." class="form-control" :rows="4"
                                                  v-model="cancel_delivery_note" required></textarea>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-primary-outline btn-close"
                                            @click="show_cancel_delivery_modal = false">Cancel
                                    </button>
                                    <button type="button" class="btn btn-danger" action="submit" @click="cancelDelivery">
                                        Yes, please
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--end-->
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import {mapGetters, mapMutations} from 'vuex'

    export default {

        data() {
            return {
                app: this.$root.$data.app,
                orders: [],
                show_reject_order_modal: false,
                last_sync_date: "",
                additional_status_data: {
                    notes: "",
                    delay: 0,
                    expected_date: null,
                },
                filter: "CREATED",
                selected_order: null,
                filter_counts: {
                    created: 0,
                    accepted: 0,
                    ready: 0,
                    dispatched: 0,
                    rejected: 0,
                    cancelled: 0,
                    completed: 0,
                },
                status_action: null,
                delivery_services: [],
                show_request_delivery_modal: false,
                log_device_interval: null,
                show_orders_interval: null,
                delivery_time: '', //'' important
                login_user: null,
                delivery_cancellation_reasons: [
                    'Taking too long',
                    'Requested in error',
                    'Order cancelled',
                ],
                cancellation_reasons: [
                    'Customer requested cancellation',
                    'Not accepting orders at this time',
                    'Item unavailable',
                    'Unable to deliver',
                ],
                status_action_text: null,
                show_payment_modal: false,
                payment: null,
                search_query: '',
                new_order_audio: new Audio('/audio/neworder.mp3'),
                show_delivery_details_modal: false,
                show_cancel_delivery_modal: false,
                cancel_delivery_note: '',
                show_map_spinner: false,
                recompute: 0, //rendering hook
                enable_delivery_services: true,
                use_date_picker: false,
            }
        },

        mounted() {
            this.setLoading(false)
            if (this.user) {
                if(!this.token_checked)
                    this.refreshToken(true)
                else
                    this.startIntervals()
            } else {
                this.$router.replace({name: 'login'})
            }
        },

        methods: {
            ...mapMutations([
                'setLoading',
                'setToken',
                'logout',
                'setStoreStatus',
                'setTokenChecked',
            ]),

            orderMinDate(order){
                return this.app.moment(order.requested_at).format()
            },

            getRequestedTime(order) {
                if(this.app.moment(order.requested_at).isSame(this.app.moment(), "day"))
                    return this.app.moment(order.requested_at).format('HH:mm')
                else
                    return this.app.moment(order.requested_at).format('ddd Do, MMM HH:mm')
            },

            showDeliveryDetails(){
                this.show_map_spinner = true
                this.show_delivery_details_modal = true
            },

            showCancelDelivery(){
                this.show_delivery_details_modal = false
                this.cancel_delivery_note = ''
                this.show_cancel_delivery_modal = true
            },

            cancelDelivery() {
                this.app.http.delete(`order_collect/${this.selected_order.id}/delivery/${this.selected_order.deliveries[0].id}`, {
                        reason: this.cancel_delivery_note,
                        sale_id: this.selected_order.id,
                        staff_id: this.staff_id,
                        register_id: this.register_id,
                    })
                    .then(response => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Cancelled delivery',
                            text: response.data.message,
                        })
                        this.show_cancel_delivery_modal = false
                        this.setLoading(true)
                        this.showOrders()
                        this.setLoading(false)
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.message,
                        })
                    })
            },

            orderSelected(order) {
                if(this.selected_order)
                    return order.id === this.selected_order.id
            },

            beginRecordPayment() {
                this.show_payment_modal = true
                this.payment = {
                    payment_method: 'CARD',
                    payment_amount: this.sale_due
                }
            },

            tenderAmount(amount) {
                if (this.payment.payment_amount === this.sale_due)
                    this.payment.payment_amount = parseFloat(amount).toFixed(2)
                else
                    this.payment.payment_amount = (parseFloat(this.payment.payment_amount) + amount).toFixed(2)

                if (this.payment.payment_amount >= parseFloat(this.sale_due)) {
                    this.recordPayment(true)
                }
            },

            printOrder() {
                window.print()
            },

            // needs more testing
            recordPayment(using_cash) {
                let message = 'Payment completed'
                let change = 0
                if (using_cash)
                    this.payment.payment_method = 'CASH'

                change = (this.payment.payment_amount - this.sale_due).toFixed(2)
                //amount being sent is more than due
                if (parseFloat(this.payment.payment_amount) > parseFloat(this.sale_due)) {
                    if(using_cash)
                        this.payment.payment_change = (this.payment.payment_amount - this.sale_due).toFixed(2)
                    this.payment.payment_amount = (parseFloat(this.sale_due) + parseFloat(change)).toFixed(2)
                }
                // there is change / due amount remaining
                if (change != 0) {
                    message = (change > parseFloat(0)) ?
                        `Issue a change of ${this.currency + change}` :
                        `Payment remaining ${this.currency + Math.abs(change).toFixed(2)}`
                }

                this.app.http.post(`order_collect/${this.selected_order.id}/payment`, {
                        ...this.payment,
                        staff_id: this.staff_id,
                        register_id: this.register_id,
                    })
                    .then(response => {
                        Swal.fire({
                            icon: (Math.abs(change) > parseFloat(0)) ? 'warning' : 'success',
                            title: (change >= parseFloat(0)) ? '' : 'Amount due',
                            text: message,
                        })
                        this.show_payment_modal = false
                        //so payment is updated immediately
                        this.setLoading(true)
                        this.showOrders()
                        this.setLoading(false)

                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.error,
                        })
                    })
            },

            playSoundNotification(){
                if (this.sound_enabled == false)
                    return
                if(this.filter_counts.created > 0) {
                     // Attempt to play sound, may fail before user interaction
                    this.new_order_audio.play()
                        .catch((err) => {
                            //do nothing
                        })
                }
            },

            displayNotification(order) {
                // Check notification API is available (not the case in iOS)
                if ('Notification' in window == false)
                    return

                // Stop if permission is not granted
                if (Notification.permission != 'granted')
                    return

                // Send notification
                const title = `New ${(order.vendor === 'gtc') ? 'Goodeats' : 'web'} order`
                const body = `${this.currency}${parseFloat(order.order_total).toFixed(2)} - ${''
                    } ${order.sale.sale_items.length} items | ${''
                    } ${order.fulfilment_type_name}${(order.requested_at) ? ' - by ' + this.getRequestedTime(order) : ''}`

                this.app.push.create(
                    title,
                    {
                        body,
                        icon: '/images/goodeats-logo.png',
                        timeout: 4000,
                        onClick: function () {
                            window.focus()
                            this.close()
                        }
                    })
            },

            startIntervals() {
                this.update_status_data = {
                    register_id: this.register_id,
                    staff_id: this.staff_id,
                    device_model: "Web",
                    device_version: null,
                    send_customer_email: true,
                }
                this.get_sales_data = {
                    register_id: this.register_id,
                    staff_id: this.staff_id,
                    device_model: "Web",
                    device_version: null,
                    app_version: '0.1',
                    supports_cancelled: true,
                }
                this.ready = true
                this.logDevice()
                this.showOrders()
                this.log_device_interval = setInterval(() => {
                    this.logDevice()
                }, 600000)
                this.show_orders_interval = setInterval(() => {
                    this.showOrders()
                }, 10000)
                this.refresh_token_interval = setInterval(() => {
                    this.refreshToken()
                }, env.jwt_refresh_min * 60000)
                this.sound_notification_interval = setInterval(() => {
                    this.playSoundNotification()
                }, 3000)
            },

            clearIntervals() {
                clearInterval(this.log_device_interval)
                clearInterval(this.show_orders_interval)
                clearInterval(this.refresh_token_interval)
                clearInterval(this.sound_notification_interval)
            },

            refreshToken(start_intervals) {
                this.app.http.get('refresh_token')
                    .then(response => {
                        this.setTokenChecked(true)
                        console.log(response, 'Token refreshed')
                        if (this.user)
                            this.setToken(response.data.token)
                        if (start_intervals)
                            this.startIntervals()
                    })
                    .catch(error => {
                        console.log(error)
                        Swal.fire({
                            icon: 'error',
                            text: "Session timeout, please login",
                        })
                    })
            },

            showOrders() {
                this.app.http.get('order_collect/get_sales', {
                        ...this.get_sales_data,
                        last_sync_date: this.last_sync_date,
                    })
                    .then(response => {
                        if (this.store_is_offline != response.data.store_is_offline)
                            this.setStoreStatus(response.data.store_is_offline)
                        // hide / show request delivery button
                        if (Object.keys(response.data.delivery_services).length > 0)
                            this.enable_delivery_services = true
                        else
                             this.enable_delivery_services = false
                        if (response.data.results.length > 0) {
                            response.data.results.forEach(order => {
                                let order_exist = this.orders.find((existing_order, index) => {
                                    if (existing_order.id === order.id) {
                                        this.orders[index] = order
                                        if (this.selected_order) {
                                            if (this.selected_order.id === order.id) {
                                                this.selected_order = order
                                                if (['ACCEPTED', 'READY', 'DISPATCHED'].includes(order.order_status))
                                                    this.filter = 'ACCEPTED'
                                                else
                                                    this.filter = order.order_status
                                            }
                                        }
                                        return true
                                    }
                                    return false
                                })
                                if (!order_exist) {
                                    if (order.order_status == 'CREATED')
                                        this.displayNotification(order)
                                    this.orders.push(order)
                                    if (this.filter == 'CREATED'){
                                        this.$nextTick(() => {
                                            if (this.$refs.orders_container)
                                                this.$refs.orders_container.scrollTop = this.$refs.orders_container.scrollHeight
                                        })
                                    }

                                    return false
                                }
                            })
                            this.recompute++;
                            this.countOrdersbyFilter()
                        }

                        if (!this.selected_order && this.filter != 'SEARCH') {
                            this.showOrder(this.filteredOrders[0])
                        }

                        this.last_sync_date = response.data.last_sync_date
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.error,
                        })
                    })
            },


            formatDate(date) {
                return this.app.moment(date).format('ddd Do MMM HH:mm')
            },

            filterOrders() {
                return this.pointFilteredOrders.filter(order => {
                    if (this.filter === "ACCEPTED") {
                        return ['READY', 'DISPATCHED', this.filter].includes(order.order_status)
                    }
                    return order.order_status == this.filter
                })
            },

            countOrdersbyFilter() {
                this.filter_counts = {
                    created: 0,
                    accepted: 0,
                    ready: 0,
                    dispatched: 0,
                    rejected: 0,
                    cancelled: 0,
                    completed: 0,
                }
                this.pointFilteredOrders.forEach(order => {
                    this.filter_counts[order.order_status.toLowerCase()]++
                })
            },

            showRejectModal() {
                this.show_reject_order_modal = true
                this.additional_status_data.notes = ""
            },

            changeStatus(status) {
                Swal.fire({
                    title: 'Confirm',
                    text: 'Change this order status to ' + status.toLowerCase() + '?',
                    showCancelButton: true,
                    type: 'question',
                    confirmButtonText: 'Proceed'
                }).then((isConfirm) => {
                    if (isConfirm.value) {
                        let expected = null
                        if (this.selected_order.order_status == 'CREATED' && this.selected_order.requested_at != null) {
                            let time = this.app.moment(this.additional_status_data.expected_date)
                            if (this.use_date_picker){
                                expected = {
                                    expected_date: time.format("YYYY-MM-DD"),
                                    expected_time_minutes: (time.hour() * 60) + time.minute()
                                }
                            } else {
                                time = this.app.moment(this.additional_status_data.expected_date)
                                    .add(parseInt(this.additional_status_data.delay), 'minutes')
                                expected = {
                                    expected_date: time.format("YYYY-MM-DD"),
                                    expected_time_minutes: (time.hour() * 60) + time.minute()
                                }
                            }
                        }
                        this.app.http.post(`order_collect/update_status/${this.selected_order.id}`,
                            {
                                ...this.update_status_data,
                                ...expected,
                                status: status,
                                notes: this.additional_status_data.notes,
                            })
                            .then(response => {
                                this.show_reject_order_modal = false
                                Swal.fire({
                                    icon: 'success',
                                    text: response.data.message,
                                })
                                this.showOrders()

                                 //reset additional data
                                this.resetAdditionalStatusData()
                            })
                            .catch(error => {
                                Swal.fire({
                                    icon: 'error',
                                    text: error.response.data.message,
                                })
                                this.show_reject_order_modal = false
                            })
                    }
                })

                if (status === "REJECT") {
                    this.cancelReject()
                }
            },

            resetAdditionalStatusData () {
                 this.additional_status_data = {
                    delay: 0,
                    expected_date: null,
                    notes: "",
                }
            },

            cancelReject() {
                this.show_reject_order_modal = false
                this.additional_status_data.notes = ""
            },

            logDevice() {

                // Get network type
                let network_type = null
                try {
                    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
                    if (connection && connection.type)
                        network_type = connection.type
                } catch (e) { }

                this.app.http.post('device', {
                        app: 'goodeats_terminal',
                        register_id: this.register_id,
                        device_model: "Web",
                        app_launched_at: this.launched_at,
                        app_version: 'Hosted',
                        os: "Browser",
                        install_uuid: this.install_id,
                        network_type,
                        in_foreground: document.hidden == false,
                        viewport_width: document.documentElement.clientWidth,
                        viewport_height: document.documentElement.clientHeight,
                        last_web_sync_at: this.last_sync_date
                    })
                    .then(response => {

                    })
            },

            changeFilter(text) {
                this.filter = text
                if(text != 'SEARCH')
                    this.showOrder(this.filteredOrders[0])
            },

            appendToNote(text) {
                if (!this.additional_status_data.notes) {
                    this.additional_status_data.notes = text
                    return
                }
                this.additional_status_data.notes += '\n' + text
            },

            appendToCancelDeliveryNote(text) {
                if (!this.cancel_delivery_note) {
                    this.cancel_delivery_note = text
                    return
                }
                this.cancel_delivery_note += '\n' + text
            },

            showOrder(order) {
                this.selected_order = order
                this.resetAdditionalStatusData()
                let datetime = order.expected_at ? order.expected_at : order.requested_at
                this.additional_status_data.expected_date = this.app.moment(datetime).format()
                // On mobile, scroll to order details
                if (document.documentElement.clientWidth < 500 && this.$refs.order_details_section)
                    this.$refs.order_details_section.scrollIntoView({ behavior: 'smooth' })
            },

            getDeliveryServices() {
                this.app.http.get(`order_collect/${this.selected_order.id}/delivery_services`)
                    .then(response => {
                        this.delivery_time = this.app.moment().add(3, 'minutes').format('HH:mm')
                        this.delivery_services = response.data.data.delivery_services
                        this.show_request_delivery_modal = true
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.error,
                        })
                    })
            },

            requestDelivery(service) {
                this.app.http.post(`order_collect/${this.selected_order.id}/deliver`, {
                        sale_id: this.selected_order.id,
                        vendor: service.vendor,
                        request_collection_at: this.app.moment(this.delivery_time, 'H:mm:ss').format("YYYY-MM-DD HH:mm:ss"),
                        package_size_id: service.details.default_package_size,
                    })
                    .then(response => {
                        this.show_request_delivery_modal = false
                        Swal.fire({
                            icon: 'success',
                            text: response.data.message,
                        })
                        // Update immediately
                        this.setLoading(true)
                        this.showOrders()
                        this.setLoading(false)
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.message,
                        })
                    })
            },

            orderDueDate(order) {
                const dates = [order.expected_at, order.requested_at, order.created_at]
                const date = dates.find(date => date != null)
                return this.formatDate(date)
            },

            filterOrdersByRef(){
                if(this.search_query === ''){
                    return []
                }
                return this.pointFilteredOrders.filter(order => {
                    if (order.order_ref.includes(this.search_query)) {
                        return order
                    }
                })
            },

            stringEmpty(str) {
                return str == null || str.trim().length == 0
            }
        },

        computed: {

            ...mapGetters([
                'user',
                'register_id',
                'staff_id',
                'client',
                'outlet',
                'logo',
                'currency',
                'install_id',
                'launched_at',
                'store_is_offline',
                'sound_enabled',
                'order_search_enabled',
                'collection_points',
                'ignore_collection_points',
                'token_checked',
            ]),

            filteredOrders: function () {
                if(this.filter == 'SEARCH')
                    return this.filterOrdersByRef()
                return this.filterOrders()
            },

            total: function(){
                return (parseFloat(this.selected_order.total) + parseFloat(this.selected_order.sales_tips)).toFixed(2)
            },

            total_paid: function () {
                return this.selected_order.sale.sale_payments
                    .map(p => parseFloat(p.payment_amount_inc_tips) - parseFloat((p.payment_change) ? p.payment_change : 0))
                    .reduce((a, z) => a + z, 0) || 0
            },

            sale_due: function () {
                return parseFloat(
                    Math.max(
                        0, (parseFloat(this.total)).toFixed(2) - parseFloat(this.total_paid).toFixed(2))
                ).toFixed(2) || 0
            },

            pointFilteredOrders: function () {
                this.recompute;
                if(this.ignore_collection_points)
                    return this.orders
                return this.orders.filter(order => {
                    if (this.collection_points.includes(order.oc_collection_point_id)) {
                        return order
                    }
                })
            }
        },

        watch: {
            user: function (val) {
                if (!val) {
                    this.clearIntervals()
                    this.$router.replace({name: 'login'})
                    return
                }
            },
            order_search_enabled: function (val) {
                if(val == true)
                    return this.filter = 'SEARCH'
                return this.changeFilter('CREATED')
            },
            pointFilteredOrders: function () {
                this.countOrdersbyFilter()
            }
        }
    }
</script>

<style scoped>
    .max-width-350 {
        max-width: 350px;
    }

    #delivery-map {
        height: 50vh;
    }

    .col-red {
        color: red
    }

    .avoid-wrap {
        overflow: hidden
    }

    #search-container{
        border-radius: 0;
        background-color: white;
    }

    .print-show {
        display: none;
    }

    .font-big {
        font-size: 20px;
        line-height: 30px;
    }

    .outlet-img {
        max-width: 100px;
    }

    .font-18 {
        font-size: 18px;
    }

    .vendor-img {
        max-width: 70px;
    }

    .deliver-service {
        cursor: pointer;
        font-size: 14px;
    }

    .delivery-services-container {
        max-height: 50vh;
        overflow-y: auto;
    }

    .font-weight-medium {
        font-weight: 500;
    }

    .unpaid-container {
        border-radius: 65px;
        border: 5px solid #fec;
        width: 130px;
        height: 130px;
        color: #fd8;
    }

    #payment-status {
        max-width: 400px;
    }

    .payment-text {
        font-weight: 500;
        text-transform: uppercase;
    }

    .paid-container {
        border-radius: 60px;
        border: 5px solid #dfc;
        width: 120px;
        height: 120px;
        color: #ae8;
    }

    .product-extra {
        font-size: 14px;
        white-space: pre;
        margin-top: -30px;
        margin-bottom: -20px;
    }

    .quantity-container {
        color: #5C3598;
        width: 35px;
        background-color: #FFC82C;
    }

    .font-14 {
        font-size: 14px;
    }

    .sale-items-container {
        max-height: 500px;
        overflow-y: auto;
    }

    .sale-payments-container {
        margin-top: 20px;
    }

    .btn-status {
        width: 120px;
    }

    .btn-payment {
        width: 160px;
    }

    .btn-150 {
        width: 150px !important;
    }

    .color-grey {
        color: grey;
    }

    #main-body {
        height: 90vh;
    }

    #goodeats-logo {
        max-width: 150px;
    }

    .vendor-image {
        max-width: 60px;
    }

    .no-data-alert {
        border-radius: 0;
        margin: 0;
    }

    #orders-outer-container {
        background-color: #258;
        padding: 0;
    }

    #filters-container {
        background-color: #fff;
        overflow-x: auto;
    }

    #orders-container {
        background-color: #146;
        max-height: 70vh;
        overflow-y: auto;
    }

    .cursor-hover {
        cursor: pointer;
    }

    .order-selector {
        cursor: pointer;
        font-size: 14px;
        background-color: #258;
        color: whitesmoke;
        padding: 10px;
    }

    .order-selector.selected {
        border-left: 5px solid #37d4b0 !important;
        background-color: #146 !important;
        color: white;
    }

    filter:hover {
        cursor: pointer;
    }

    .btn-advance:hover {
        color: green;
    }

    .filter {
        background-color: transparent;
        border: none;
        border-radius: 0;
    }

    .filter.search-icon {
        width: 60px
    }

    .filter.selected {
        border-bottom: 2px solid #146;
        color: #146;
        font-size: 15px;
    }

    .btn-close {
        box-shadow: none !important;
        padding-right: 10px;
    }

    .showpassword {
        font-size: 14px;
    }

    .btn-card {
        width: 120px;
    }

    .noSelect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .custom-badge {
        color: white;
        background-color: #146;
        border-radius: 50px;
        font-weight: 400;
        min-width: 20px;
        max-width: 40px;
        font-size: 12px;
    }

    .order-selector-text-ref,
    .order-selector-text-date {
        font-weight: bold;
    }

    .sale-notes {
        white-space: pre-line;
        color: red;
    }

    .delivery-notes {
        white-space: pre-line;
    }

    @media print {

        .quantity-container{
            color: dimgrey
        }

        .print-font-20 {
            font-size: 20px;
        }

        .phone-number {
            text-decoration: none;
        }

        .font-italic {
            font-style: normal !important;
        }

        .print-show {
            display: unset;
        }

        .print-hide {
            display: none;
        }

        .print-lg {
            font-size: 20px;
        }

        .btn {
            display: none;
        }

        .vendor-image {
            background-color: black;
        }

        .order-selector {
            display: none;
        }

        .order-selector-text {
            color: black;
        }

        .font-14 {
            font-size: 17px;
        }

        .font-18 {
            font-size: 21px;
        }

        .custom-header {
            font-size: 23px;
        }

        p {
            font-size: 20px;
        }

        .sale-items-container {
            max-height: initial;
        }
    }
</style>